import { useNavigate, useParams } from "react-router-dom";
import { useWellnessCheck } from "../features/wellnessCheck/useWellnessCheck";
import { PartialLinkText, SpinAnimation } from "@twioku/common_components";
import { AnswererProfileImage } from "../components/AnswererProfileImage";
import { format } from "date-fns";
import { useRequireAgreedAnswerer } from "../features/answerer/hooks/useRequireAgreedAnswerer";
import { Path } from "../routes/PagePath";

export const WellnessCheckDetailPage = () => {
    const params = useParams();
    const id = params.id as string;
    const answererId = params.answererId as string;

    const navigate = useNavigate();
    const { wellnessCheck, isLoading: isWellnessCheckLoading } =
        useWellnessCheck(id);
    const {
        answerer,
        isLoading: isGetAnswererLoading,
        isAgreed,
    } = useRequireAgreedAnswerer(answererId);

    const isLoading = isWellnessCheckLoading || isGetAnswererLoading;

    if (isLoading) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    if (!wellnessCheck || !answerer || !isAgreed) {
        navigate(Path.notFound, { replace: true });
        return null;
    }

    return (
        <div className="px-4 pb-8 pt-2">
            <div className="mb-4 flex items-center gap-2">
                <AnswererProfileImage
                    answererId={answererId}
                    src={answerer.profileImagePath}
                    imageSize="medium"
                />
                <p className="text-sm">{answerer.name}</p>
            </div>

            <div className="mb-2 font-bold">
                {format(new Date(wellnessCheck.sendDate), "yyyy年MM月")}の回答
            </div>

            <ul className="flex flex-col gap-4">
                {wellnessCheck.wellnessCheckQuestions.map((question, index) => (
                    <li key={question.id} className="flex flex-col gap-2">
                        <div
                            className="border-l-4 border-primary px-3 font-bold"
                            data-testid={`wellness-check-question-${index}`}
                        >
                            {question.wellnessCheckQuestion}
                        </div>
                        <div data-testid={`wellness-check-answer-${index}`}>
                            <PartialLinkText className="ml-4 whitespace-pre-line break-all text-base">
                                {question.respondContent}
                            </PartialLinkText>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
